<footer class="footer-area">
    <div class="container">
        <div class="footer-grid">
            <div class="footer-brand">
                <div class="footer-logo-lockup" aria-label="Rayalina">
                    <img
                        src="assets/img/rayalina-logo-shape.png"
                        alt=""
                        class="footer-logo-shape"
                        decoding="async"
                    />
                    <img
                        src="assets/img/rayalina-logo-text.png"
                        alt="Rayalina"
                        class="footer-logo-text"
                        decoding="async"
                    />
                </div>
                <p>
                    Rayalina aide les vendeurs sociaux, les boutiques locales et les prestataires à gérer leurs commandes, leurs clients et leurs paiements en un seul endroit.
                </p>
            </div>
            <div>
                <h3>Produit</h3>
                <a routerLink="/" fragment="features">Fonctionnalités</a>
                <a routerLink="/" fragment="how-it-works">Comment ça marche</a>
                <a routerLink="/" fragment="pricing">Tarifs</a>
            </div>
            <div>
                <h3>Contact</h3>
                <a routerLink="/contact" class="footer-link-row">
                    <i class="bx bx-message-square-dots" aria-hidden="true"></i>
                    <span>Formulaire de contact</span>
                </a>
                <a href="mailto:contact@rayalina.com" class="footer-link-row">
                    <i class="bx bx-envelope" aria-hidden="true"></i>
                    <span>contact&#64;rayalina.com</span>
                </a>
                <a
                    href="https://www.facebook.com/rayalinapp"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="footer-link-row"
                >
                    <i class="bx bxl-facebook" aria-hidden="true"></i>
                    <span>Rayalina</span>
                </a>
                <a
                    href="https://www.instagram.com/rayalinapp"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="footer-link-row"
                >
                    <i class="bx bxl-instagram" aria-hidden="true"></i>
                    <span>&#64;rayalinapp</span>
                </a>
            </div>
        </div>
        <div class="copyright-area">
            <p>© 2026 Rayalina. Tous droits réservés.</p>
        </div>
    </div>
</footer>

<div class="go-top" [class.active]="isShow" (click)="goToTop()">
    <i class="bx bx-chevron-up"></i>
</div>
